import React from "react";
import { SvgIcon, useTheme } from "@material-ui/core";

const PublicationSystemIcon = (props) => {
  const theme = useTheme();
  const secondaryColor = theme.palette.secondary.main;
  const { disableFill, ...rest } = props;

  return (
    <SvgIcon {...rest} viewBox="0 0 48 48">
      {/* Outer container */}
      <rect x="4" y="4" width="40" height="40" rx="8" fill="currentColor" />

      {/* Megaphone — opens toward the reading direction (RTL) */}
      <path d="M33 18H27L16 12V32L27 26H33V18Z" fill="white" />

      {/* Megaphone grip */}
      <rect x="27" y="25" width="4" height="7" rx="1.5" fill="white" />

      {/* Sound wave */}
      <path
        d="M12 17.5C10.3 20.3 10.3 23.7 12 26.5"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        fill="none"
      />

      {/* "Opens another system" badge */}
      <circle cx="36" cy="36" r="6" fill={disableFill ? "" : secondaryColor} />

      {/* Outward arrow inside badge */}
      <path
        d="M33.5 38.5L38.5 33.5M34.8 33.5H38.5V37.2"
        stroke="white"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
};

export default PublicationSystemIcon;
